import { actionGenerator } from '../../utils/redux/actionGenerator';
import { globalErrorActionTypes } from '../../constants/actionTypes/globalError';
import { ITypedReduxAction } from '../../types/redux/actionType';

export const setGlobalError = actionGenerator<globalErrorActionTypes.SET_ERROR, string | null>(
  globalErrorActionTypes.SET_ERROR,
);

export type TSetGlobalErrorAction = ITypedReduxAction<globalErrorActionTypes.SET_ERROR, string | null>;

export type TGlobalErrorActions = TSetGlobalErrorAction;
